// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderType } from '@shared/utils/Trading/OrderType';
import { ErrorInformationStorage } from '../ErrorInformationStorage';
import { EventCache } from '../../Commons/cache/Event/EventCache';
export class Route {
    get IsActive() {
        return (this.RouteStatus & RouteStatus.Active) === RouteStatus.Active;
    }
    get IsRunning() {
        return this.RouteStatus === RouteStatus.ActiveAndStarted;
    }
    constructor(mess) {
        this.Name = '';
        this.Exchanges = '';
        this.AllowTypeModify = false;
        this.AllowAmountModify = false;
        this.AllowTifModify = false;
        this.AllowPriceModify = false;
        this.AllowOperationTypeModify = false;
        this.AllowExpirationDateModify = false;
        this.DictOrderTypeTifs = {}; // Record<OrderType, OrderTif[]>
        this.InstrumentDayBarMessageUpdateMode = false;
        this.ShowMode = Route.ClientShowMode.Source;
        this.RouteId = 0;
        this.QuoteRouteId = 0;
        this.IsTradable = false;
        this.IsInfo = false;
        this.RouteStatus = RouteStatus.ActiveAndStarted;
        this.QuoteDelay = null;
        this.IsNewsRoute = false;
        this.UpdateByMessage(mess);
    }
    UpdateByMessage(mess) {
        this.Name = mess.Name;
        this.Exchanges = mess.Exchanges;
        this.AllowTypeModify = mess.AllowTypeModify;
        this.AllowAmountModify = mess.AllowAmountModify;
        this.AllowTifModify = mess.AllowTifModify;
        this.AllowPriceModify = mess.AllowPriceModify;
        this.AllowOperationTypeModify = mess.AllowOperationTypeModify;
        this.AllowExpirationDateModify = mess.AllowExpirationDateModify;
        this.DictOrderTypeTifs = mess.DictOrderTypeTifs;
        if (mess.hasOwnProperty('RouteStatus')) {
            this.RouteStatus = mess.RouteStatus;
        }
        if (mess.hasOwnProperty('QuoteDelay')) {
            this.QuoteDelay = mess.QuoteDelay;
        }
        this.InstrumentDayBarMessageUpdateMode = mess.InstrumentDayBarMessageUpdateMode;
        this.ShowMode = mess.ClientShowMode === 0 ? Route.ClientShowMode.Source : Route.ClientShowMode.BuyerSeller;
        // FHolidays = new List<DateTime>();
        // string holidays = mess.Holidays;
        // if (!string.IsNullOrEmpty(holidays))
        // {
        //    string[] dates = holidays.Split(';');
        //    for (int i = 0; i < dates.Length; i++)
        //    {
        //        DateTime dt;
        //        if (DateTime.TryParseExact(dates[i], "dd-MM-yyyy", null, System.Globalization.DateTimeStyles.None, out dt))
        //            FHolidays.Add(dt);
        //    }
        // }
        this.RouteId = mess.RouteId;
        this.QuoteRouteId = mess.QuoteRouteId;
        this.IsTradable = mess.IsTradable;
        this.IsInfo = mess.IsInfo;
        this.IsNewsRoute = mess.IsNewsRoute;
    }
    /// <summary>
    /// Проверить доступность OrderType на роуте
    /// </summary>
    IsAllowableOrderType(lOrdType) {
        return this.DictOrderTypeTifs.hasOwnProperty(lOrdType);
    }
    /// <summary>
    /// Проверить доступность TIF на роуте для (для определенного orderType)
    /// </summary>
    IsAllowableTif(lTif, orderType) {
        try {
            if (orderType === OrderType.SLTPLimit) {
                orderType = OrderType.Limit;
            }
            else if (orderType === OrderType.SLTPStop) {
                orderType = OrderType.Stop;
            }
            else if (orderType === OrderType.TRStop) {
                orderType = OrderType.TrailingStop;
            }
            if (!this.DictOrderTypeTifs.hasOwnProperty(orderType)) {
                return false;
            }
            let isAllowable = false;
            const listTifs = this.DictOrderTypeTifs[orderType];
            if (listTifs != null && listTifs.includes(lTif)) {
                isAllowable = true;
            }
            return isAllowable;
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            EventCache.log(ex);
            return false;
        }
    }
    CanSubscribe() {
        if (!this.IsInfo) {
            return this.RouteId !== this.QuoteRouteId;
        }
        return this.IsInfo;
    }
}
Route.ClientShowMode = {
    Source: 0,
    BuyerSeller: 1
};
export const RouteStatus = {
    Active: 1 /* Active flag */,
    ActiveAndStarted: 5 /* Active + Started */
};
